import React, { useState } from 'react';
import { AutoBetHeader } from './autoBetHeader';
import { AutoBetContent } from './autoBetContent';
import { AutoBetFooter } from './autoBetFoother';
import { autoBetStore } from '../../store/autoBetStore';
import { doChipStore } from '../../store/doChipStore';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';
import { allChipsTotal } from '../../helpers/chipsTotal';

export const ReBet = observer(({ setIsShowBetActionModal }) => {
  const { autoBetModel, isPlay, setIsPlay } = autoBetStore;
  const { getAllBetsModels: allBetsModels } = doChipStore;
  const [autoBetState, setAutoBetState] = useState(5);
  const { balance } = userInfoStore;

  const handleAutoBetStart = () => {
    if (!allBetsModels.length || allChipsTotal(allBetsModels[0]) > balance) {
      return;
    }
    if (isPlay) {
      setIsPlay(!isPlay);
    } else if (!gameStore.isBetsClosed) {
      setIsPlay(!isPlay);
      autoBetStore.setAutoBetModel({
        autoBetCount: autoBetState - 1,
        betModel: allBetsModels[0],
      });
    }
  };

  return (
    <div className='roulette-action-popover type-2'>
      <div className='r-auto-bet-inner'>
        <AutoBetHeader setIsShowBetActionModal={setIsShowBetActionModal} autoBetModel={autoBetModel} />
        <AutoBetContent autoBetState={autoBetState} setAutoBetState={setAutoBetState} />
        <AutoBetFooter
          handleAutoBetStart={handleAutoBetStart}
          isPlay={isPlay}
          setIsPlay={setIsPlay}
          autoBetModel={autoBetModel}
          allBetsModels={allBetsModels}
        />
      </div>
    </div>
  );
});
